import { render, staticRenderFns } from "./BeaconSector.vue?vue&type=template&id=12270128&scoped=true"
import script from "./BeaconSector.vue?vue&type=script&lang=js"
export * from "./BeaconSector.vue?vue&type=script&lang=js"
import style0 from "./BeaconSector.vue?vue&type=style&index=0&id=12270128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12270128",
  null
  
)

export default component.exports